import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { VendorBranchesListFilter } from '../../../features/vendors/models/vendor-profile';
import { VendorsService } from '../../../features/vendors/services/vendors.service';
import { sortList } from '../../../features/companies/enum/company';

export interface DialogData {
  vendorId: any
}

@Component({
  selector: 'app-vendor-branches',
  templateUrl: './vendor-branches.component.html',
  styles: ``
})
export class VendorBranchesComponent {
  showFilter = false;
  dataLoading = false;

  pageIndex = 0;
  pageSize = 4;
  pageCount = 0;
  recordsData!: any | null;
  branchesList: any = []
  count_not_ended!: number
  count_ended!: number

  filterModel: VendorBranchesListFilter = new VendorBranchesListFilter();

  constructor(private dialogRef: MatDialogRef<VendorBranchesComponent>,
    private translate: TranslateService,
    private service: VendorsService,
    @Inject(MAT_DIALOG_DATA) public data: DialogData) { }


  ngOnInit(): void {
    this.GetVendorBranches()
  }

  GetVendorBranches() {
    this.dataLoading = true;
    this.filterModel.page = this.pageIndex + 1;
    this.filterModel.perPage = this.pageSize;
    this.filterModel.sort = sortList.DESC;
    this.filterModel.sortBy = 'created_at';
    this.filterModel.vendor_id = this.data?.vendorId;
    this.service.GetVendorBranches(this.filterModel).subscribe((res: any) => {
      this.branchesList = res.data.list;
      this.dataLoading = false;
    })
  }
}
